import React, { useCallback, useState } from 'react'
import styled from '@emotion/styled/macro'
import mq from 'mediaQuery'
import DomainList from './DomainList'
import FavoriteList from './FavoriteList'
import FavoritesIcon from 'assets/Favorite'
import UserIcon from 'assets/User'
import Container from '../MainLayout'
import { useFetchPage, useLocale } from 'hooks'
import QueryWrapper from 'components/querywrapper'

const sections = ['purchased', 'favorites']

const { REACT_APP_STRAPI_API_URL } = process.env
const Account = () => {
  const [selected, setSelected] = useState(sections[0])
  const { locale } = useLocale()

  const onToggle = useCallback(section => {
    setSelected(section)
  }, [])

  const fetcher = () =>
    fetch(
      `${REACT_APP_STRAPI_API_URL}/api/accounts-page?locale=${locale}&populate=*`
    ).then(res => res.json())
  const { data, isLoading, isError } = useFetchPage(
    ['/api/accounts-page', locale],
    fetcher
  )

  return (
    <QueryWrapper loading={isLoading} error={isError}>
      <Container>
        <Flex>
          {sections.map((section, index) => (
            <ToggleButton
              key={section}
              active={selected === section}
              onClick={() => onToggle(section)}
            >
              {section === 'purchased' ? (
                <UserIcon isSelected={selected === section} />
              ) : (
                <FavoritesIcon isFavorite={selected === section} />
              )}
              <>
                {section === 'purchased' ? (
                  <> {data?.PurchaseButton?.title} </>
                ) : (
                  <> {data?.FavoriteButton?.title} </>
                )}
              </>
            </ToggleButton>
          ))}
        </Flex>
        <Wrapper>
          {selected === sections[0] ? (
            <DomainList data={data} />
          ) : (
            <FavoriteList data={data} />
          )}
        </Wrapper>
      </Container>
    </QueryWrapper>
  )
}

export default Account

const Flex = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;

  ${mq.medium`
    justify-content: flex-end;
  `}
`

const ToggleButton = styled('div')`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  font-size: 16px;
  line-height: 32px;
  font-weight: 700;
  text-transform: capitalize;
  background: ${({ active }) => (active ? '#5e17fe' : '#ECEFF1')};
  color: ${({ active }) => (active ? '#000' : '#757575')};
  transition: background 0.1s ease-out, transform 0.3s ease-out;
  cursor: pointer;

  ${mq.medium`
    font-size: 20px;
    padding: 20px 50px;
  `}

  svg {
    margin-right: 10px;
  }
`

const Wrapper = styled('div')`
  width: 100%;
  margin-top: 80px;
`
